const FORMULA_CHARS = /^[=+\-@\t\r]/;

/**
 * Prefix any value beginning with a CSV formula-trigger character (= + - @ tab CR)
 * with a single quote so spreadsheet applications render the value as text rather
 * than evaluating it as a formula. Mirrors libs/csvUtils.ts on the backend.
 */
export const sanitiseCsvCell = (value: unknown): string => {
  if (value === null || value === undefined) return '';
  const s = String(value);
  if (!s) return s;
  if (s.startsWith("'") && FORMULA_CHARS.test(s.slice(1))) return s;
  return FORMULA_CHARS.test(s) ? `'${s}` : s;
};
